// src/pages/Faq.jsx
import React from "react";

const Faq = () => {
  const faqs = [
    {
      q: "¿Necesito una cuenta para usar QRBenefits?",
      a: "Sí, crear una cuenta te permite guardar tus beneficios, puntos y reseñas."
    },
    {
      q: "¿Los beneficios tienen vencimiento?",
      a: "Algunos sí. Podés ver la fecha de vencimiento dentro de cada beneficio."
    },
    {
      q: "¿Cómo sumo puntos?",
      a: "Cada beneficio usado suma puntos automáticamente a tu perfil."
    },
    {
      q: "Soy comercio, ¿cómo me sumo?",
      a: "Desde la sección 'Sumar mi negocio' podés registrarte en minutos."
    }
  ];

  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Preguntas frecuentes</h1>

      {faqs.map((item, i) => (
        <div key={i} className="mb-4">
          <h5 className="fw-bold">{item.q}</h5>
          <p className="text-secondary">{item.a}</p>
        </div>
      ))}
    </div>
  );
};

export default Faq;
